import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import TextScroll from "./textScroll.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";

var VipBotton =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipBotton, _Vue);

  function VipBotton() {
    var _this;

    _classCallCheck(this, VipBotton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipBotton).apply(this, arguments));
    _this.type = "";
    _this.key = "";
    _this.counter = 0;
    _this.beginCount = false;
    return _this;
  }

  _createClass(VipBotton, [{
    key: "randomNumer",
    value: function randomNumer(max, min) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
  }, {
    key: "renderScrollItem",
    value: function renderScrollItem(item) {
      var htmlStr = "";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(item.values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          if (typeof i === "number") {
            htmlStr += "<p class='high'>".concat(i, "</p>");
          } else {
            htmlStr += "<p class='normal'>".concat(i, "</p>");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return htmlStr;
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this2 = this;

      if (this.type === "single" && this.countTime && this.countTime > 0) {
        this.counter = this.countTime;
        this.timer = setInterval(function () {
          _this2.counter--;

          if (_this2.counter <= 0) {
            clearInterval(_this2.timer);
          }
        }, 1000);
        this.animationStyle = {
          animation: "scaleBox " + this.countTime + "s 0.5s linear"
        };
        this.beginCount = true;
      }
    }
  }, {
    key: "buyVip",
    value: function () {
      var _buyVip = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit("buyVip");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buyVip() {
        return _buyVip.apply(this, arguments);
      }

      return buyVip;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      var _this3 = this;

      this.type = this.$route.query.type;
      setTimeout(function () {
        return _this3.initData();
      }, 100);
    }
  }, {
    key: "peopleNumber",
    get: function get() {
      return this.randomNumer(1000, 2000);
    }
  }, {
    key: "changcesLeftNumber",
    get: function get() {
      return this.randomNumer(50, 100);
    }
  }, {
    key: "isRenew",
    get: function get() {
      return GeneralUtilsHelper.isRenew();
    }
  }, {
    key: "showAnimate",
    get: function get() {
      return this.counter && this.type === "single" || this.type !== "single" || !this.beginCount;
    }
  }, {
    key: "scrollList",
    get: function get() {
      var list = [[this.peopleNumber, "&nbsppeople have upgraded today"], ["Only&nbsp", this.changcesLeftNumber, "&nbspfree chances left"]];

      if (this.type === "single" && this.counter) {
        list.push([this.counter, "s left"]);
      }

      return list;
    }
  }]);

  return VipBotton;
}(Vue);

tslib_1.__decorate([Action(types.PAY_BY_IAP)], VipBotton.prototype, "payByIap", void 0);

tslib_1.__decorate([Prop({
  default: -1
})], VipBotton.prototype, "countTime", void 0);

tslib_1.__decorate([Action(types.PAY_VIP)], VipBotton.prototype, "payVip", void 0);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], VipBotton.prototype, "routerGoBack", void 0);

VipBotton = tslib_1.__decorate([Component({
  components: {
    TextScroll: TextScroll,
    loadingAnimaton: loadingAnimaton
  }
})], VipBotton);
export default VipBotton;